import React, { Fragment, useState } from 'react';
import Tinymce from '../../Tinymce';
import FeedbackGuideModal from './modals/FeedbackGuideModal';


const TeacherFeedback = ({ onProofread, sentences, setRevisions, revisions, feedbackTypeCode, isReadOnly }: any) => {
  const [showGuideVisible, setShowGuideVisible] = useState(false);
  const onSetRevisions = (index: number, revision: string) => {
    if (setRevisions) {
      const newRevisions = [...revisions!];
      newRevisions[index] = revision;
      setRevisions(newRevisions);
    }
  };

  return (
    <>
      {/* s: 화면 확인용*/}
      <div className="row m-auto align-items-center ">
        <div className="pointer">
          <div onClick={() => setShowGuideVisible(true)}>
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 16 16"
              color="black"
              height="1em"
              width="1em"
              xmlns="http://www.w3.org/2000/svg"
              style={{ color: 'black' }}
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
              <path
                d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"></path>
            </svg>
            <p className="mb-0" style={{ color: 'black' }}>
              Guide!
            </p>
          </div>
        </div>
        <div className="m-auto">
          <h1>Teacher’s Feedback</h1>
        </div>
        <div className="text-right">
          <button type="button" className="btn btn-primary"
                  onClick={onProofread}
                  disabled={isReadOnly}

          >
            <i className="ic">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
              >
                <path
                  fill="none"
                  d="M0 0h19.1v19.1H0V0z"
                ></path>
                <path
                  fillRule="evenodd"
                  fill="#FFF"
                  d="M17.848 17.852a.501.501 0 0 1-.707 0l-2.198-2.198a3.977 3.977 0 0 1-2.45.844 4.005 4.005 0 0 1-4.001-3.999 4.006 4.006 0 0 1 4.001-4.001 4.005 4.005 0 0 1 4.001 4.001 3.97 3.97 0 0 1-.844 2.448l2.198 2.198a.499.499 0 0 1 0 .707zm-5.355-8.354c-1.655 0-3 1.346-3 3.001a3.003 3.003 0 0 0 3 2.999 3.005 3.005 0 0 0 3.002-2.999 3.005 3.005 0 0 0-3.002-3.001zm0 1.501a1.5 1.5 0 0 0-1.499 1.5.5.5 0 0 1-1.001 0c0-1.379 1.122-2.5 2.5-2.5a.5.5 0 1 1 0 1zM4.957 5.261a.664.664 0 0 1 1.204 0l1.321 2.838a.463.463 0 0 1-.421.659h-.006a.462.462 0 0 1-.427-.28l-.197-.458H4.677l-.193.457a.465.465 0 1 1-.849-.378l1.322-2.838zm1.148 1.951-.541-1.283h-.022l-.535 1.283h1.098zm-2.013 6.907h2.2a.5.5 0 0 1 0 1h-2.2a.5.5 0 1 1 0-1zm0-3.18h2.7a.5.5 0 1 1 0 1h-2.7a.5.5 0 1 1 0-1zM8.63 4.877c.283 0 .514.231.514.515v2.852a.514.514 0 1 1-1.03 0V5.392c0-.284.231-.515.516-.515zm4.912 2.822a.357.357 0 0 1-.357-.357V5.026h-1.871a.386.386 0 0 1-.385-.385v-1.87H2.763v14.455h6.975c.196 0 .355.16.355.357v.046a.356.356 0 0 1-.355.355l-7.331.015a.394.394 0 0 1-.386-.387l-.03-15.228c0-.208.179-.386.387-.386h8.906c.089 0 .179.03.238.09.03.029 2.287 2.255 2.287 2.286.058.059.088.118.088.177v2.791c0 .197-.16.357-.355.357zM11.67 3.275v.95h.95l-.95-.95z"
                ></path>
              </svg>
            </i>
            AI Proofreading
          </button>
        </div>
      </div>
      {
        sentences?.map((sentence: any, index: number) => {
          const count = revisions[index]?.replace(/(<[^>]*>|&nbsp;)?/g, '').length;

          return (
            <Fragment key={'teacher-feedback-' + index}>
              <div className="sentence" dangerouslySetInnerHTML={{__html: sentence}} />
              <Tinymce
                content={revisions![index]}
                setContent={content => onSetRevisions(index, content)}
                charLimit={2000}
              />
              <div className="count">{count ?? 0} Characters (with tags)</div>
            </Fragment>
          )
        })
      }
      {showGuideVisible &&
        <FeedbackGuideModal
          visible={showGuideVisible}
          setVisible={setShowGuideVisible}
          feedbackTypeCode={feedbackTypeCode}
        />
      }
  </>
  )
}

export default TeacherFeedback
;